<template>
  <div>
    <gj-alert
      type="warning"
      :closable="false"
      :border="false"
    >
      <div class="gj-import-alert">
        <!-- <div class="gj-import-alert--title">导入规则：</div> -->
        <ol class="gj-import-alert--content">
          <slot name="content">
            <li v-for="(rule, index) in rules"
                :key="index"
                class="gj-import-alert--rule"
                :style="rule.style"
            >
              <div class="gj-import-alert_box">
                <div class="gj-import-alert--dot"></div>
              </div>
              <span>{{ rule.text || rule }}</span>
            </li>
          </slot>
        </ol>
      </div>
  </gj-alert>
  </div>
</template>

<script>
  export default {
    name: "gj-import-alert",
    props: {
      rules: {}
    }
  }
</script>

<style lang="scss" scoped>
  .el-alert{
    padding: 8px 12px;
    & /deep/.el-alert__content{
      padding: 0;
    }
  }
  
  .gj-import-alert {
    font-size: 12px;
  }
  .gj-import-alert--title {
    margin-bottom: 10px;
  }
  .gj-import-alert--title,
  .gj-import-alert--content {
    color: #666666;
    margin: 0;
    padding-left: 0px;
  }
  .gj-import-alert--rule {
    font-size: 12px;
    list-style-type: none;
    display: flex;
    // align-items: center;
    line-height: 26px;
    .gj-import-alert_box{
      height: 24px;
      display: flex;
      align-items: center;
      margin-right: 8px;
    }
    .gj-import-alert--dot{
      min-height: 8px;
      min-width: 8px;
      max-width: 8px;
      max-height: 8px;
      border-radius: 50%;
      background: #999999;
      opacity: 0.4;
    }
  }
  /deep/ .el-alert--warning {
    background-color: #F6F8FB;
    border-radius: 2px;
  }
</style>
